export function convertToHoursAndMin(n) {
  if (n === 0) {
    return 'N/A';
  }
  const num = n;
  const hours = num / 60;
  const rhours = Math.floor(hours);
  const minutes = (hours - rhours) * 60;
  const rminutes = Math.round(minutes);
  const value = `${rhours}h ${rminutes}m`;

  return value;
}

export function addDaysToDate(date, days) {
  let totalMiliseconds = Date.parse(date);
  totalMiliseconds += 86400000 * days;
  return new Date(totalMiliseconds);
}

export const convertHoursToMinutes = hours => hours * 60;
export const convertMinutesToHours = minutes => Math.floor(minutes / 60);
